import { buildStorefrontApiPath, api } from "@/lib/api";
import type { PublicCategoryTreeNode, CategoryNode } from "@/lib/storefront-acl";
import {
  unwrapData,
  mapTreeNodeToCategory,
  ALL_CATEGORIES_NODE,
} from "@/lib/storefront-acl";

// Re-exports públicos para consumidores existentes
export type { CategoryNode, SubCat } from "@/lib/storefront-acl";

export async function fetchCategories(): Promise<CategoryNode[]> {
  const res = await api.get(buildStorefrontApiPath("/categories/tree"));
  const tree = unwrapData<PublicCategoryTreeNode[]>(res.data);

  const safeTree = Array.isArray(tree) ? tree : [];

  return [ALL_CATEGORIES_NODE, ...safeTree.map(mapTreeNodeToCategory)];
}
